/** Namespace `eventLog` — wird befüllt während der Komponenten-Migration. */
export const eventLog = {
  de: {
    eventLog: {
      title: 'Event Log',
      last24h: 'Letzte 24h',
      lastRefresh: 'Zuletzt: {{time}}',
      reload: 'Neu laden',
      errorLoad: 'Fehler beim Laden',
      noData: 'Keine Daten',
      // Pie-Legende
      pie2xx: '2xx OK',
      pie3xx: '3xx Redirect',
      pie4xx: '4xx Client',
      pie5xx: '5xx Server',
      pieOutbound: 'Outbound',
      // Stat-Karten
      statTotal: 'Gesamt',
      statErrors: 'Fehler',
      statErrorRate: 'Fehlerrate',
      topErrorEndpoints: 'Top-Fehler-Endpoints',
      // Filter
      filterErrors: 'Fehler',
      filter4xx: '4xx',
      filter5xx: '5xx',
      filterOutbound: 'Outbound',
      filterAll: 'Alle',
      allMethods: 'Alle Methoden',
      searchPath: 'Pfad suchen…',
      entriesCount: '{{count}} Einträge',
      // Empty-States
      noErrors24h: 'Keine Fehler in den letzten 24h',
      noEntries: 'Keine Einträge gefunden',
      // Tabellenköpfe
      colTime: 'Zeit',
      colMethod: 'Method',
      colStatus: 'Status',
      colPath: 'Pfad / Service',
      colDuration: 'Dauer',
      // Detail
      errorLabel: 'Fehler',
      requestBody: 'Request Body',
      responseBody: 'Response Body',
    },
  },
  es: {
    eventLog: {
      title: 'Registro de eventos',
      last24h: 'Últimas 24 h',
      lastRefresh: 'Última: {{time}}',
      reload: 'Recargar',
      errorLoad: 'Error al cargar',
      noData: 'Sin datos',
      // Leyenda del gráfico
      pie2xx: '2xx OK',
      pie3xx: '3xx Redirección',
      pie4xx: '4xx Cliente',
      pie5xx: '5xx Servidor',
      pieOutbound: 'Saliente',
      // Tarjetas de estadísticas
      statTotal: 'Total',
      statErrors: 'Errores',
      statErrorRate: 'Tasa de errores',
      topErrorEndpoints: 'Endpoints con más errores',
      // Filtros
      filterErrors: 'Errores',
      filter4xx: '4xx',
      filter5xx: '5xx',
      filterOutbound: 'Saliente',
      filterAll: 'Todos',
      allMethods: 'Todos los métodos',
      searchPath: 'Buscar ruta…',
      entriesCount: '{{count}} entradas',
      // Estados vacíos
      noErrors24h: 'Sin errores en las últimas 24 h',
      noEntries: 'No se han encontrado entradas',
      // Encabezados de tabla
      colTime: 'Hora',
      colMethod: 'Método',
      colStatus: 'Estado',
      colPath: 'Ruta / Servicio',
      colDuration: 'Duración',
      // Detalle
      errorLabel: 'Error',
      requestBody: 'Request Body',
      responseBody: 'Response Body',
    },
  },
};
